import script from "./BlockDefault.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockDefault.vue?vue&type=script&setup=true&lang=js"

import "./BlockDefault.vue?vue&type=style&index=0&id=32b37c16&lang=scss"

const __exports__ = script;

export default __exports__